// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"320":"a011dff2","334":"658bd04a"}[chunkId] + ".css";
};